<template>
  <div class="candidate identification signup-prompt">
    <Conversation v-model="conversation" @scroll="$emit('scroll')" @done="$emit('done')" />
  </div>
</template>

<script>
// Components
import Conversation from '@/components/prompts/Conversation'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: { Conversation },

  created() {
    this.initialize()
  },

  data() {
    return {
      conversation: [],
    }
  },

  methods: {
    initialize() {
      this.conversation = [
        {
          key: 1,
          type: 'prompt',
          text: 'idPrompt01',
          next: 2,
        },
        {
          key: 2,
          type: 'prompt',
          text: 'idPrompt02',
          component: { name: 'IdentityForm', next: 3 },
        },
        {
          key: 3,
          next: 4,
          text: 'idResponse01',
          type: 'response',
        },
        {
          key: 4,
          type: 'prompt',
          text: 'idPrompt03',
          last: true,
        },
      ]
    },
  },
}
</script>
